import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import ActiveTrek from './pages/ActiveTrek';
import MyTreks from './pages/MyTreks';
import TrekDetail from './pages/TrekDetail';
import Settings from './pages/Settings';
import BottomNav from './components/BottomNav';

function Shell() {
  const location = useLocation();
  const hideNav = location.pathname.startsWith('/trek') && location.pathname !== '/treks';
  return (
    <div className="mobile-shell topo-pattern">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trek" element={<ActiveTrek />} />
        <Route path="/treks" element={<MyTreks />} />
        <Route path="/treks/:id" element={<TrekDetail />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
      {!hideNav && <BottomNav />}
      <Toaster theme="dark" position="bottom-center" richColors closeButton />
    </div>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
